import { graphql } from '@/__generated__';
import { useCacheMonitor } from '@/context/DiscoveryUrqlProvider';
import { useQueryStable } from '../useQueryStable';

export const GetTags = graphql(/* GraphQL */ `
  query Tags($environmentId: BigInt!) {
    environment(id: $environmentId) {
      applied {
        lastUpdatedAt
        tags {
          name
        }
      }
    }
  }
`);

type TagsProps = {
  environmentId: number | undefined;
  pause?: boolean;
};

export const useTags = ({ environmentId = 0, pause }: TagsProps) => {
  const query = useQueryStable({
    query: GetTags,
    variables: { environmentId },
    pause: pause || !environmentId,
  });

  useCacheMonitor({ applied: query[0].data?.environment.applied?.lastUpdatedAt });

  return query;
};
